import is from '@/utils/is';

import React, { ReactNode, ElementType, memo, Fragment, forwardRef } from 'react';

interface MapProps {
  list: any[];
  render: (item: any, index: number) => ReactNode;
  wrapper?: ElementType;
  className?: string;
  style?: any;
  id?: string;
}

const Map = (
  { list, render, wrapper, className, id, ...restProps }: MapProps,
  ref: React.Ref<HTMLElement>,
) => {
  if (is.not.empty.array(list) && is.function(render)) {
    const Wrapper = wrapper || (className && 'div');
    const tsx = list.map(render);

    if (Wrapper) {
      return (
        <Wrapper id={id} ref={ref} className={className} {...restProps}>
          {tsx}
        </Wrapper>
      );
    }
    return <Fragment>{tsx}</Fragment>;
  }
  return null;
};

export default memo(forwardRef(Map));
